import { PopoverPortal as UIKitPopoverPortal } from "@circle-react-shared/uikit/PopoverPortal";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useShouldShowMessagingRoutes } from "@circle-react/hooks/useIsMessagingEnabled";

import { DEFAULT_POPPER_OPTIONS } from "../constants";
import { Banner } from "./Banner";
import { DMsPopoverButton } from "./DMsPopoverButton";
import { HeaderUIKit } from "./HeaderUIKit";
import { TabHeader } from "./TabHeader";

export const DirectMessages = () => {
  const { shouldShowMessagingRoutes } = useShouldShowMessagingRoutes();
  const { isViewOnlyMasquerading } = usePunditUserContext();

  if (!shouldShowMessagingRoutes) {
    return null;
  }

  return (
    <UIKitPopoverPortal
      renderButton={isOpen => <DMsPopoverButton isOpen={isOpen} />}
      className={classNames(
        "border-primary bg-primary size-full max-h-[37rem] max-w-[30rem] rounded-md border shadow-lg",
        {
          "cursor-not-allowed": isViewOnlyMasquerading,
        },
      )}
      popperOptions={DEFAULT_POPPER_OPTIONS}
      shouldHideOnMdScreens={false}
    >
      <div
        className={classNames("size-full overflow-hidden rounded-md", {
          "pointer-events-none": isViewOnlyMasquerading,
        })}
        data-testid="direct-messages-drawer"
      >
        <Banner />
        <HeaderUIKit />
        <TabHeader />
      </div>
    </UIKitPopoverPortal>
  );
};
